// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M13 3L7 9M8.82 3H13L13 7.18M11 10V11C11 12.1 10.1 13 9 13H5C3.9 13 3 12.1 3 11V7C3 5.9 3.9 5 5 5H6',
];
